


import './index.scss'
const TrophyText = () => {

    return (
        <div className="trophy">
            <div className="trophy-bg-left"></div>
            <div className='trophy-text'>爱の衣柜</div>
            <div className="trophy-bg-right"></div>

        </div>
    )
}
export default TrophyText;